const { ASSETS_PATH } = process.env;

const images = {
  search: {
    imageMessage: `${ASSETS_PATH as string}images/search/image_mensagem.png`,
  },
};

export default images;
